// Need to use the React-specific entry point to import createApi

import { baseApiAuth } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const notificationApi = baseApiAuth.injectEndpoints({
  reducerPath: "notificationApi",

  // mode: "no-cors",
  // credentials: "include",
  endpoints: (builder) => ({
    pushNotification: builder.mutation({
      query: (body) => {
        return {
          url: '/send-test-notification',
          method: "POST",
          body,
      };
      },
    }),
    notificationStatus: builder.query({
      query: (param) => {
        return {
          url: 'GETPUSHSTATUS',
          method: "GET",
        };
      },
      // keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getNotificationList: builder.query({
      query: (param) => {
        return {
          url: '/notifications',
          method: "GET",
        };
      },
      // keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    addMedia: builder.mutation({
      query: (body) => {
        return {
          url:`/upload-attachments`,
          method: "POST",
          body,
        };
      },
    }),
    updateProfile: builder.mutation({
      query: (body) => {
        return {
          url:``,
          method: "PATCH",
          body,
        };
      },
    }),
    getMyProfile: builder.query({
      query: (body) => {
        return {
          url:``,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { 
  usePushNotificationMutation,
  useNotificationStatusQuery,
  useGetNotificationListQuery,
  useAddMediaMutation,
  useUpdateProfileMutation,
  useGetMyProfileQuery,
 } = notificationApi;
